// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { CopyBoardView } from 'app/scripts/views/board/CopyBoardView';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const copyBoard = function (this: any, e: any) {
  stopPropagationAndPreventDefault(e);
  return PopOver.toggle({
    // @ts-expect-error TS(2339): Property 'closest' does not exist on type 'JQueryS... Remove this comment to see the full error message
    elem: $(e.target, this.$el).closest('.js-copy-board'),
    view: new CopyBoardView({ model: this.model, modelCache: this.modelCache }),
  });
};
